import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { SharedModule } from 'avn/shared/shared.module';

import { ActivateAccountComponent } from './activate-account/activate-account.component';
import { AuthCheckRoutingModule } from './auth-check-routing.module';
import { BusinessSignUpComponent } from './business-sign-up/business-sign-up.component';
import { CustomerSignUpComponent } from './customer-sign-up/customer-sign-up.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetComponent } from './reset/reset.component';
import { SignInComponent } from './sign-in/sign-in.component';
import { SignUpComponent } from './sign-up/sign-up.component';

@NgModule({
  declarations: [
    SignInComponent,
    SignUpComponent,
    ResetComponent,
    ForgotPasswordComponent,
    BusinessSignUpComponent,
    CustomerSignUpComponent,
    ActivateAccountComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatCheckboxModule,
    SharedModule,
    AuthCheckRoutingModule
  ]
})
export class AuthCheckModule {}
